/**
 * サウナストーブ出力計算ツール
 * Shopify テーマ専用実装
 */

// 商品データ配列
//
// 【2026-09-04】**適用体積を harvia.jp（Harvia日本法人の公式）の「下限〜上限」に置き換えた。**
//   出所は `https://harvia.jp/products/<型式>/` の仕様表（2026-09-04 取得）。
//   それまでの maxVolume は実質 kW×1.0 の一本値で、**公式の帯の下限あたり**だった
//   （CLUB15 は 13 に対し公式 12.6〜22）。管理者の指摘で全機種を取り直したもの。
//   経緯と全機種の突き合わせは `3d-customizer/docs/保留リスト.md` 第39節。
//     minVolume   … 公式の下限（下回る＝その部屋には大きすぎる）
//     maxVolume   … 公式の上限（超える＝能力不足。従来どおりの意味）
//     maxRoomTemp … 公式の「推奨サウナ室温度」(℃以下)。**80℃組と90℃以上組に割れる**。
//                   80℃組（CILINDRO6 / SPIRIT6 / SPIRIT9 / LEGEND125 / CILINDRO PRO 132 / 26）は
//                   石を大量に積んで低温高湿で使う型で、90℃以上で使う自宅サウナには向かない。
//                   ⚠️「サウナ室の温度設定の目安 最大110℃」とは**別の欄**。混同しないこと。
//
// 【2026-07-23】DELTA3 の maxVolume は管理者の公称ブラケット(3㎥)。公式は 1.5〜2.7 だが、
//   公式の帯には 2.7〜3.0㎥ の穴があるため**上書きしない**と決めた(2026-09-04)。
//   KIP6/KIP8 の上限は公式(7 / 11㎥)へ戻した。**KIP6 の下限だけ公称ブラケットの3**
//   （公式は4。DELTA3の上限3と同じ境界なので片側だけ採ると3.0〜4.0㎥が互換機種から外れる）。
//
// ※こちらは汎用計算機なので選定は従来どおり「上限の小さい順→出力順」のまま
//   (互換性優先=KIP系を先頭に、はカスタマイザー側のみ)。
// ⚠️ **VIRTA PRO はここにだけ残してある**（カスタマイザーは 2026-08-31 に除外）。
//   harvia.jp にページが無く(404)公式の帯が取れないので minVolume を持たない。
//   ⚠️ 除外しない理由だった「外すと13.1〜18㎥の答えが26.4kWへ飛ぶ」は、
//      公式の帯にした結果 **CLUB12(〜18.5) / CLUB15(〜22) が覆うので既に成り立たない**。
//      残すかどうかは商品担当の判断（`docs/保留リスト.md` 第39節）。
const electricHeaters = [
  {id: "harvia-delta3", power: 2.7, minVolume: 1.5, maxVolume: 3, maxRoomTemp: 90, name: "Harvia DELTA3", url: "/products/harvia-delta3"},
  {id: "harvia-wall-4.5", power: 4.5, minVolume: 3, maxVolume: 6, maxRoomTemp: 100, name: "Harvia WALL4.5", url: "/products/harvia-wall4-5"},
  {id: "harvia-cilindro-6", power: 5.5, minVolume: 5.5, maxVolume: 9.1, maxRoomTemp: 80, name: "Harvia CILINDRO6", url: "/products/harvia-cilindro-6"},
  {id: "harvia-kip-6", power: 5.5, minVolume: 3, maxVolume: 7, maxRoomTemp: 100, name: "Harvia KIP6", url: "/products/harvia-kip6"},
  {id: "harvia-spirit-6", power: 6.0, minVolume: 5, maxVolume: 8, maxRoomTemp: 80, name: "Harvia SPIRIT6", url: "/products/harvia-spirit-6"},
  {id: "harvia-wall-6", power: 6.0, minVolume: 5, maxVolume: 8, maxRoomTemp: 100, name: "Harvia WALL6", url: "/products/harvia-wall6"},
  {id: "harvia-kip-8", power: 7.4, minVolume: 6, maxVolume: 11, maxRoomTemp: 100, name: "Harvia KIP8", url: "/products/harvia-kip8"},
  {id: "harvia-wall-8", power: 7.4, minVolume: 6.5, maxVolume: 11.1, maxRoomTemp: 100, name: "Harvia WALL8", url: "/products/harvia-wall8"},
  {id: "harvia-spirit-9", power: 9.0, minVolume: 8, maxVolume: 14, maxRoomTemp: 80, name: "Harvia SPIRIT9", url: "/products/harvia-spirit-9"},
  {id: "harvia-club-12", power: 11.6, minVolume: 10.3, maxVolume: 18.5, maxRoomTemp: 110, name: "Harvia CLUB12", url: "/products/harvia-club-12"},
  {id: "harvia-legend-125", power: 11.6, minVolume: 12.2, maxVolume: 22.5, maxRoomTemp: 80, name: "Harvia LEGEND125", url: "/products/harvia-legend125"},
  {id: "harvia-cilindro-pro-132", power: 13.2, minVolume: 11, maxVolume: 20, maxRoomTemp: 80, name: "Harvia CILINDRO PRO 132", url: "/products/harvia-cilindro-pro-132"},
  // ※ Harvia LEGEND15 (13.8kW) は廃番のため削除（商品ページ404 / 全商品176件を走査して不在を確認、2026-07-19）。
  //    同出力帯は下の CLUB15 が実在する。
  {id: "harvia-club-15", power: 13.8, minVolume: 12.6, maxVolume: 22, maxRoomTemp: 110, name: "Harvia CLUB15", url: "/products/harvia-club-15"},
  {id: "harvia-mythos-eos", power: 13.9, minVolume: 16.7, maxVolume: 23.2, maxRoomTemp: 110, name: "Harvia MYTHOS EOS", url: "/products/harvia-mythos-eos"},
  // ⚠️ **VIRTA PRO は 2026-09-07 に削除した。** Shopify の商品ステータスが `UNLISTED`
  //    （＝コレクションに出さない・実質の廃盤予定）で、**非公開の商品を推奨に出さない**
  //    という管理者指示による。3Dカスタマイザーは 2026-08-31 に既に外している。
  //    外しても穴は空かない: 13.1〜18㎥ は CLUB12(〜18.5) と CLUB15(〜22) が覆う。
  //    戻すときは harvia.jp の公式値（現在404）を取り直してから。
  //    旧行: {id:"harvia-virta-pro", power:18.5, maxVolume:18.0, name:"Harvia VIRTA PRO", url:"/products/harvia-virta-pro"}
  {id: "harvia-cilindro-pro-26", power: 26.4, minVolume: 25, maxVolume: 50, maxRoomTemp: 80, name: "Harvia CILINDRO PRO 26", url: "/products/harvia-cilindro-pro-26"},
  {id: "harvia-watermill-eos", power: 27.2, minVolume: 40, maxVolume: 55, maxRoomTemp: 110, name: "Harvia WATERMILL EOS", url: "/products/harvia-watermill-eos"},
  {id: "harvia-club-pro", power: 27.4, minVolume: 37, maxVolume: 51.8, maxRoomTemp: 110, name: "Harvia CLUB PRO", url: "/products/harvia-club-pro"}
];

const woodHeaters = [
  {id: "harvia-legend-150", power: 16.0, minVolume: 6, maxVolume: 13, maxRoomTemp: 90, name: "Harvia LEGEND150", url: "/products/harvia-legend-150"},
  {id: "harvia-m3", power: 16.5, minVolume: 6, maxVolume: 13, maxRoomTemp: 90, name: "Harvia M3", url: "/products/harvia-m3"},
  {id: "harvia-legend-240", power: 21.0, maxVolume: 21.0, name: "Harvia LEGEND240", url: "/products/harvia-legend-240"}
];

// DOMContentLoaded イベント
document.addEventListener('DOMContentLoaded', function() {
  console.log('サウナストーブ計算ツールが初期化されました');
  
  const form = document.getElementById('sauna-calculator-form');
  if (!form) {
    console.error('計算フォームが見つかりません');
    return;
  }

  // サウナタイプ変更イベント
  const saunaTypeRadios = document.querySelectorAll('input[name="saunaType"]');
  saunaTypeRadios.forEach(radio => {
    radio.addEventListener('change', handleSaunaTypeChange);
  });
  
  // 初期状態設定
  handleSaunaTypeChange();

  // フォーム送信イベント
  form.addEventListener('submit', function(e) {
    e.preventDefault(); // ページ遷移を確実に防止
    
    console.log('フォーム送信開始 - ページ遷移防止');
    
    try {
      // 1. フォームデータ取得
      const inputs = getFormInputs();
      console.log('取得した入力データ:', inputs);
      
      // 2. バリデーション
      if (!validateInputs(inputs)) {
        console.log('バリデーションエラー');
        return false; // 確実に処理を停止
      }
      
      // 3. 計算実行
      const result = calculateRequiredPower(inputs);
      console.log('計算結果:', result);
      
      // 4. 商品推奨
      const products = findRecommendedProducts(result.effectiveVolume, inputs.heaterType);
      console.log('推奨商品:', products);
      
      // 5. 結果表示
      displayResults(result, products, inputs);
      
      // 6. GA4イベント送信
      sendGA4Event('サウナストーブ計算実行', {
        event_category: 'ツール利用',
        有効体積: result.effectiveVolume.toFixed(2),
        推奨出力: result.requiredPower.toFixed(2),
        サウナタイプ: inputs.saunaType,
        設置場所: inputs.location
      });
      
    } catch (error) {
      console.error('計算処理エラー:', error);
      alert('計算中にエラーが発生しました。入力内容をご確認ください。');
    }
    
    return false; // ページ遷移を確実に防止
  });
});

/**
 * サウナタイプ変更処理
 */
function handleSaunaTypeChange() {
  const saunaType = getRadioValue('saunaType') || 'box';
  const boxDimensions = document.getElementById('box-dimensions');
  const barrelDimensions = document.getElementById('barrel-dimensions');
  const locationGroup = document.getElementById('location-group');
  
  if (saunaType === 'barrel') {
    // バレルサウナの場合
    boxDimensions.style.display = 'none';
    barrelDimensions.style.display = 'block';
    locationGroup.style.display = 'none'; // バレルサウナは設置場所選択不要
  } else if (saunaType === 'loghouse') {
    // ログハウスサウナの場合
    boxDimensions.style.display = 'block';
    barrelDimensions.style.display = 'none';
    locationGroup.style.display = 'none'; // ログハウスサウナは設置場所選択不要（屋外固定）
  } else {
    // ボックスタイプの場合
    boxDimensions.style.display = 'block';
    barrelDimensions.style.display = 'none';
    locationGroup.style.display = 'block';
  }
}

/**
 * フォームデータ取得
 */
function getFormInputs() {
  const saunaType = getRadioValue('saunaType') || 'box';
  
  const inputs = {
    // サウナタイプ
    saunaType: saunaType,
    
    // 補正要素
    glassArea: parseFloat(document.getElementById('glassArea').value) || 0,
    stoneArea: parseFloat(document.getElementById('stoneArea').value) || 0,
    
    // 条件（ラジオボタンから取得）
    location: saunaType === 'barrel' ? 'indoor' : saunaType === 'loghouse' ? 'outdoor' : (getRadioValue('location') || 'indoor'), // バレルサウナは室内固定、ログハウスサウナは屋外固定
    heaterType: 'electric' // 電気ストーブ固定
  };
  
  if (saunaType === 'barrel') {
    // バレルサウナの寸法
    inputs.barrelDiameter = parseFloat(document.getElementById('barrelDiameter').value) || 0;
    inputs.barrelLength = parseFloat(document.getElementById('barrelLength').value) || 0;
  } else {
    // ボックスタイプ・ログハウスの寸法
    inputs.length = parseFloat(document.getElementById('length').value) || 0;
    inputs.width = parseFloat(document.getElementById('width').value) || 0;
    inputs.height = parseFloat(document.getElementById('height').value) || 0;
  }
  
  return inputs;
}

/**
 * ラジオボタンの値を取得
 */
function getRadioValue(name) {
  const radioButton = document.querySelector(`input[name="${name}"]:checked`);
  return radioButton ? radioButton.value : '';
}

/**
 * 入力バリデーション
 */
function validateInputs(inputs) {
  const errors = [];
  
  if (inputs.saunaType === 'barrel') {
    // バレルサウナのバリデーション
    if (inputs.barrelDiameter <= 0) errors.push('直径を入力してください');
    if (inputs.barrelLength <= 0) errors.push('長さを入力してください');
    
    // 寸法の妥当性チェック
    if (inputs.barrelDiameter > 10) errors.push('直径は10m以下で入力してください');
    if (inputs.barrelLength > 50) errors.push('長さは50m以下で入力してください');
    
    // 補正面積の妥当性チェック（バレル表面積概算）
    const barrelSurfaceArea = Math.PI * inputs.barrelDiameter * inputs.barrelLength + 2 * Math.PI * Math.pow(inputs.barrelDiameter/2, 2);
    if (inputs.glassArea > barrelSurfaceArea) errors.push('ガラス面積がバレル表面積より大きすぎます');
    if (inputs.stoneArea > barrelSurfaceArea) errors.push('ストーン面積がバレル表面積より大きすぎます');
    
  } else {
    // ボックスタイプ・ログハウスのバリデーション
    if (inputs.length <= 0) errors.push('長さを入力してください');
    if (inputs.width <= 0) errors.push('幅を入力してください');
    if (inputs.height <= 0) errors.push('高さを入力してください');
    
    // 寸法の妥当性チェック
    if (inputs.length > 50) errors.push('長さは50m以下で入力してください');
    if (inputs.width > 50) errors.push('幅は50m以下で入力してください');
    if (inputs.height > 10) errors.push('高さは10m以下で入力してください');
    
    // 補正面積の妥当性チェック
    const totalArea = inputs.length * inputs.width * 6; // 6面の概算面積
    if (inputs.glassArea > totalArea) errors.push('ガラス面積が室内面積より大きすぎます');
    if (inputs.stoneArea > totalArea) errors.push('ストーン面積が室内面積より大きすぎます');
  }
  
  if (errors.length > 0) {
    alert('入力エラー:\n' + errors.join('\n'));
    return false;
  }
  
  return true;
}

/**
 * バレルサウナ体積計算
 */
function calculateBarrelVolume(diameter, length) {
  // 円筒体積計算: π × (半径)² × 長さ
  const radius = diameter / 2;
  
  // バレルサウナは木材厚み分を除く（厚み50mm想定）
  const wallThickness = 0.05; // 5cm厚み
  const innerDiameter = diameter - (wallThickness * 2);
  const innerRadius = innerDiameter / 2;
  
  if (innerRadius <= 0) {
    return 0; // 厚みが直径を超える場合
  }
  
  const innerVolume = Math.PI * innerRadius * innerRadius * length;
  
  return innerVolume;
}

/**
 * 必要出力計算（ガイドライン準拠）
 */
function calculateRequiredPower(inputs) {
  let volume;
  
  if (inputs.saunaType === 'barrel') {
    // バレルサウナ計算
    volume = calculateBarrelVolume(inputs.barrelDiameter, inputs.barrelLength);
  } else {
    // ボックスタイプ・ログハウス計算
    volume = inputs.length * inputs.width * inputs.height;
  }
  
  // ガイドライン準拠の補正計算
  //
  // 🔴 **【2026-09-05 管理者】補正はこのまま残す。「3Dカスタマイザーだけ別」。**
  //    この日、いったん「3Dに合わせて全廃」する変更を入れて本番へ押したが、
  //    **指示は3D側だけの話**だったため戻した（コミット e008ec2 の次）。
  //    ⚠️ **「3Dと式が違う」を理由にここを全廃しにいかないこと。**
  //
  // ■ ①②のガラス・石は Harvia 公式そのまま（2026-09-07 に一次資料で確認）
  //    Harvia の据付説明書:「1m² の石・ガラス等の**非断熱面**は、サウナ室の容積が
  //    **1.2㎥増えた**のと同等の出力増が必要」。**加算式**であって体積に掛ける式ではない。
  //    社内資料でも同じ一文が日本語で確認できる
  //    （`商品登録/2026-9_ブロスサウナ価格改定・LOOP追加/…/改良型SAT_取扱説明書_2026-05-21.pdf` p9
  //      「非断熱面積1m² に付き 1.2m³ の体積を加算する必要があります」）。
  const glassCorrection = inputs.glassArea * 1.2; // ①非断熱面積補正
  const stoneCorrection = inputs.stoneArea * 1.2; // ②ストーン壁面積補正
  
  // 適用体積の計算
  const effectiveVolume = volume + glassCorrection + stoneCorrection;
  
  // ③屋外設置の補正（体積補正）。**屋外に据えるものは種類を問わず ×1.2。**
  //
  // 【2026-09-07 変更】ログハウス ×1.5 / バレル ×1.5 を **どちらも ×1.2 にした。**
  //
  // ■ 1.5 の出どころと、なぜ外したか
  //    1.5 は Harvia の「**サウナ室の内壁が非断熱の丸太**なら体積を1.5倍」という規定。
  //    ＝**丸太小屋の躯体がそのままサウナ室の壁**（無垢材70〜100mm級）を指していて、
  //    **設置場所の係数ではない**。idetox が扱うのは壁厚 30mm（バレル）/ 38mm（円筒）/
  //    50mm（LTシリーズ）の造作サウナで、この規定には当たらない。実データも一致する:
  //      ・商品ページの推奨kW ÷ 素の容積 … 屋内36商品の中央値 **1.03**（最大サイズ基準0.84）
  //      ・バレルの商品ページ … 直径1.8×3.0m(10.3㎥) → 10.5kW ＝ **約1.0**
  //      ・実際の見積り … 3000×3000(19.8㎥) に CLUB15(13.8kW) ＝ **約0.70**
  //    どれも1.5では売っていない。1.5のままだと 3000×3000 が CLUB PRO 27.4kW になり、
  //    営業が「オーバースペック」として外した CILINDRO PRO 26 より大きい機種が出る。
  //
  // ■ なぜ屋外に ×1.2 は残すのか（Harvia 公式には無い、idetox の目安）
  //    壁からの熱損失は温度差に比例する。サウナ室90℃なら
  //      屋内20℃ → 温度差70K（基準） / 屋外+5℃ → 85K(**1.21**) / 0℃ → 90K(1.29)
  //    ＝ **×1.2 は外気+5℃相当**。冬の予熱ぶんも乗るので妥当か、やや控えめ。
  //    2026-09-07 の白木さんの指示「屋外という条件で×1.2は残ります」と一致する。
  //
  // ⚠️ **3Dカスタマイザーもこの ×1.2 で揃えてある**（`3d-customizer/web/src/stoves.js`
  //    の `OUTDOOR_FACTOR`）。片方だけ動かさないこと。
  let finalEffectiveVolume = effectiveVolume;
  if (inputs.saunaType === 'loghouse' || inputs.saunaType === 'barrel'
      || inputs.location === 'outdoor') {
    finalEffectiveVolume *= 1.2; // 屋外設置の補正（ログハウス・バレルは屋外固定）
  }
  
  // 必要出力 = 有効体積 × 1kW/㎥（Harvia の目安。断熱室で 1㎥ あたり約1kW）
  //
  // 【2026-07-20 変更】旧実装は 9㎥ を境に 1.67*V^0.66 / 2.81*V^0.59 の2式を切り替えていたが、
  //   ・境界で 7.1kW → 10.3kW と不連続にジャンプする（2式の交点は V≒1691㎥ で実用域外）
  //   ・どちらの式も出力を過小評価し、部屋の体積より小さい定格の機種が選ばれていた
  //     （例: 6㎥→5.5kW機 / 8.9㎥→7.4kW機 / 15㎥→13.9kW機 いずれも定格体積不足）
  //   という2つの不具合があったため、指数式を廃止。
  //   Harvia 本来の選定方法（有効体積を求め、機種の定格最大体積と突き合わせる）に統一した。
  //   実機の定格も全機種 kW≒最大体積 で揃っており、1kW/㎥ は商品データとも整合する。
  //   実際の機種選定は findRecommendedProducts() が maxVolume で行う（表示kWは目安値）。
  const requiredPower = Math.round(finalEffectiveVolume * 10) / 10;
  
  return {
    basicVolume: volume,
    effectiveVolume: finalEffectiveVolume,
    requiredPower: requiredPower,
    saunaType: inputs.saunaType
  };
}

/**
 * 商品推奨ロジック
 */
function findRecommendedProducts(effectiveVolume, heaterType) {
  // 電気ストーブのみ対応
  const products = electricHeaters;

  // 有効体積を **harvia.jp 公式の適用体積の帯**（minVolume〜maxVolume）で突き合わせる。
  // 旧実装は「機種のkW >= 計算出力」で絞っていたため、定格体積が部屋より小さい機種が
  // 選ばれることがあった。体積そのもので突き合わせることで能力不足を構造的に排除する。
  //
  // ⚠️ **下限は「入るものがあれば優先」で、外れても落とさない。**
  //    公式の帯には穴がある（0〜1.5㎥ / 23.2〜25.0㎥）ので、下限で機械的に落とすと
  //    そこだけ「該当なし」になる。3Dカスタマイザー(stoves.js の recommendStoves)と
  //    **同じ2段構え**にしてあるので、片方だけ直さないこと。
  // ① 上限を満たす（能力が足りる）②そのうち90℃以上で使える ③そのうち下限も満たす
  // の順に絞り、**空でなかった最初の集合**を使う。3Dカスタマイザーの recommendStoves と同じ。
  //
  // ⚠️ **公式値を持たない機種（maxRoomTemp / minVolume が無い）は②③を通さない。**
  //    harvia.jp にページが無い VIRTA PRO がそれ。無い値を「条件を満たす」と読むと、
  //    帯で他が落ちたぶん**相対的に上位へ繰り上がる**（実際 2.99㎥ の推奨にまで出ていた）。
  const MIN_ROOM_TEMP = 90;
  const enough = products.filter(p => p.maxVolume >= effectiveVolume);
  const warm = enough.filter(p => (p.maxRoomTemp || 0) >= MIN_ROOM_TEMP);
  const inBand = list => list.filter(p => isFinite(p.minVolume) && p.minVolume <= effectiveVolume);
  const suitable = ([inBand(warm), warm, inBand(enough), enough].find(l => l.length) || [])
    .sort((a, b) => a.maxVolume - b.maxVolume || a.power - b.power);

  // 最大機種でも足りない場合は推奨しない（結果欄で「該当なし」扱い）
  if (suitable.length === 0) {
    return [];
  }

  // 適合する中から小さい順に最大3機種
  return suitable.slice(0, 3);
}

/**
 * 結果表示
 */
function displayResults(result, products, inputs) {
  const resultsDiv = document.getElementById('calculation-results');
  const requiredPowerSpan = document.getElementById('required-power');
  const recommendationsDiv = document.getElementById('product-recommendations');
  const recommendedProductsSection = document.querySelector('.recommended-products');

  // 結果表示（推奨出力のみ）
  requiredPowerSpan.textContent = result.requiredPower.toFixed(1);

  // 商品推奨表示
  if (products.length > 0) {
    // 商品がある場合
    recommendationsDiv.innerHTML = '';
    products.forEach(product => {
      const productCard = createProductCard(product);
      recommendationsDiv.appendChild(productCard);
    });
    recommendedProductsSection.style.display = 'block';
  } else {
    // 商品がない場合（推奨出力が大きすぎる場合）
    recommendedProductsSection.style.display = 'none';
  }

  // 結果エリアを表示
  resultsDiv.style.display = 'block';

  // 計算結果を引き継いだ「サウナ選びサポート」への動的CTAを挿入
  // （結果表示を確実にするため display 後に実行し、失敗しても結果は残す）
  try {
    injectConsultCTA(result, inputs);
  } catch (e) {
    console.warn('相談CTAの挿入をスキップしました:', e);
  }

  // 結果にスクロール
  resultsDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

/**
 * 計算結果を引き継いだ相談CTAを結果エリアに挿入
 * 推奨出力・有効体積・ストーブ種別をクエリで /pages/sauna-support_inquiry へ渡す。
 * 計算のたびに古いCTAを消して作り直す。
 */
function injectConsultCTA(result, inputs) {
  const resultsDiv = document.getElementById('calculation-results');
  if (!resultsDiv) return;

  const existing = document.getElementById('calc-consult-cta');
  if (existing) existing.remove();

  const power = result.requiredPower.toFixed(1);
  const volume = result.effectiveVolume.toFixed(1);
  const heater = (inputs && inputs.heaterType === 'wood') ? '薪' : '電気';

  const params = new URLSearchParams({
    from: 'stove_calc',
    power: power,
    volume: volume,
    heater: heater
  });

  // 計算に使ったサウナ室の内寸を引き継ぐ（※設置スペース=外寸とは別物なのでメモとして渡す）
  let dims = '';
  if (inputs) {
    if (inputs.saunaType === 'barrel') {
      if (inputs.barrelDiameter && inputs.barrelLength) {
        dims = '直径' + inputs.barrelDiameter + 'm × 長さ' + inputs.barrelLength + 'm';
      }
    } else if (inputs.length && inputs.width && inputs.height) {
      dims = '長さ' + inputs.length + 'm × 幅' + inputs.width + 'm × 高さ' + inputs.height + 'm';
    }
  }
  if (dims) params.set('dims', dims);

  const url = '/pages/sauna-support_inquiry?' + params.toString();

  const box = document.createElement('div');
  box.id = 'calc-consult-cta';
  box.className = 'calc-consult-cta';
  box.innerHTML =
    '<p class="calc-consult-cta__lead">この条件（推奨 ' + power + 'kW・有効体積 ' + volume + '㎥）に合う機種とサウナを、プロが無料でご提案します。</p>' +
    '<div class="calc-consult-cta__btn"><a href="' + url + '" data-calc-consult-link>計算結果をそのまま無料相談する</a></div>';

  const disclaimer = resultsDiv.querySelector('.calculator-disclaimer');
  if (disclaimer) {
    resultsDiv.insertBefore(box, disclaimer);
  } else {
    resultsDiv.appendChild(box);
  }

  const link = box.querySelector('[data-calc-consult-link]');
  if (link) {
    link.addEventListener('click', function() {
      sendGA4Event('サウナ選定CTAクリック_計算機', {
        event_category: '導線',
        推奨出力: power,
        有効体積: volume
      });
    });
  }

  // CTA表示を計測（計算実行と対で送客率を見る）
  sendGA4Event('サウナ選定CTA表示_計算機', {
    event_category: '導線',
    推奨出力: power,
    有効体積: volume
  });
}

/**
 * 商品カード作成
 */
function createProductCard(product) {
  const card = document.createElement('div');
  card.className = 'product-card';
  
  card.innerHTML = `
    <a href="${product.url}" class="card-overlay"></a>
    <h5 class="product-name">${product.name}</h5>
    <p class="product-specs">${product.power}kW | 適用体積 ${product.minVolume ? product.minVolume + '〜' : '〜'}${product.maxVolume}㎥${product.maxRoomTemp ? ' | 推奨室温 ' + product.maxRoomTemp + '℃以下' : ''}</p>
    <a href="${product.url}" class="product-link">詳細を見る</a>
  `;
  
  return card;
}

/**
 * GA4イベント送信
 */
function sendGA4Event(eventName, parameters) {
  if (typeof gtag !== 'undefined') {
    gtag('event', eventName, parameters);
    console.log('GA4イベント送信:', eventName, parameters);
  } else {
    console.log('GA4未設定 - イベント:', eventName, parameters);
  }
}

console.log('サウナストーブ計算ツールのJavaScript読み込み完了');
